/* eslint-disable  @typescript-eslint/no-explicit-any */
/* Yulia: I added the line below because raw because raw is literally any  */
export interface FingerprintSchema {
  user_id?: number;
	fingerprint_id: string;
	raw: Record<string, any>
	timestamp: number;
}

export interface SessionData {
  browserType: string;
  route: string;
  updatedAt?: number;
  initialGameId?: number;
}

export interface FingerprintAttributes {
  // expected to be set once during fist session in web mobile - and consumed once in pwa onboarding
  initialGameId?: number;
  // expected to be set once userId is set (for now... maybe we have more updates in the future)
  updatedAt?: number;

  // session data for each supported browser type
  web?: SessionData;
  mobileWeb?: SessionData;
  pwa?: SessionData;
}

export interface Fingerprint {
  id: number;
  userId?: number;
  createdAt: Date;
  attributes: FingerprintAttributes;
}

export const getFingerprintFromSchema = (schema: FingerprintSchema): Fingerprint => ({
  id: Number(schema.fingerprint_id),
  userId: schema.user_id ? Number(schema.user_id) : undefined,
  createdAt: new Date(Number(schema.timestamp)),
  attributes: schema.raw as FingerprintAttributes,
});

export const getSchemaFromFingerprint = (fingerprint: Fingerprint): FingerprintSchema => ({
  user_id: fingerprint.userId,
	fingerprint_id: fingerprint.id.toString(),
	raw: fingerprint.attributes,
	timestamp: fingerprint.createdAt.getTime(),
});